import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useEffect} from "react";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {SetStateType} from "@/types/generic/SetState.type";

/**
 * Once the other group updates, reset the local selected amenities state to match the global.
 *
 * This is caused by the fact that we do not separate selected amenities by groups, but just append a single array of all selected amenities.
 * Groups are just a display feature.
 */
export default function useUpdateLocalCountAmenityStateWhenOtherGroupsUpdate(
    setSingleSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>,
    setReturnSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
) {
    const {
        singleSelectedAmenities,
        returnSelectedAmenities,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    useEffect(() => {
        setSingleSelectedAmenities(singleSelectedAmenities || {})
        setReturnSelectedAmenities(returnSelectedAmenities || {})
    }, [singleSelectedAmenities, returnSelectedAmenities]);
}